import React, {useContext, useEffect, useState} from "react"
import { BarcodeScanner, useTorch } from "react-barcode-scanner";
import moment from "moment";
import Barcode from "react-barcode";
import InputText from "./InputText";
import CrossIcon from "../../../icons/CrossIcon";
import RandomIcon from "../../../icons/RandomIcon";
import TrashIcon from "../../../icons/TrashIcon";
import ScanBarcodeIcon from "../../../icons/ScanBarcodeIcon";
import BarcodeBuilder from "../../../../class/tool/BarcodeBuilder";
import BackofficeContext from "../../../../context/BackofficeContext";
import "react-barcode-scanner/polyfill";
import "../../../../css/form/InputBarcode.css";

const InputBarcode = props => {
    moment.locale('fr');
    const { barcodes, storeSettings, classname, readonly, handleChange } = props
    const { setEvent } = useContext(BackofficeContext);
    const { isTorchSupported, isTorchOn, setIsTorchOn } = useTorch();
    const [ barcode, setBarcode ] = useState("");
    const [ scanner, setScanner ] = useState(false);
    const [ detect, setDetect ] = useState(false);
    const scannerOptions = {
        delay: 500,
        formats: [
            "code_128",
            "code_39",
            "code_93",
            "codabar",
            "ean_13",
            "ean_8",
            "itf",
            "qr_code",
            "upc_a",
            "upc_e"
        ]
    }

    const buildList = () => {
        if (barcodes.length === 0) {
            return <li className="empty">Aucun</li>
        }
        else {
            // sort by dates desc
            barcodes.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at)
            });

            return barcodes.map((row, index) => (
                <li key={ index } className={ row.deleted_at !== null ? "red" : "" }>
                    <div className="wrapBarcodePicture">
                        <Barcode value={ row.barcode } format="EAN13" height={ 40 } />
                    </div>
                    <div className="wrapBarcodeText">
                        <p className="barcode">{ row.barcode }</p>
                        <p className="date">
                            {
                                buildDate(row)
                            }
                        </p>
                    </div>
                    {
                        row.deleted_at === null
                        && <TrashIcon handleClick={ () => { removeBarcodeInValues(row.barcode) } } />
                    }
                    <div className="clearing" />
                </li>
            ))
        }
    }
    const buildDate = row => {
        if (row.toAdd)
            return "En cours d'ajout..."
        else if (row.toDelete)
            return "En cours de suppression..."
        else {
            if (row.deleted_at !== null)
                return "Supprimé le " + moment(row.deleted_at).format("dddd Do MMMM YYYY, LT")
            else
                return "Ajouté le " + moment(row.created_at).format("dddd Do MMMM YYYY, LT")
        }
    }
    const inputBarcode = (attribute, returnType, value) => {
        setBarcode(value)
    }
    const addBarcode = () => {
        if (barcode.length === 8 || barcode.length === 13) {
            insertBarcodeInValues(barcode)
            setBarcode("")
        }
        else {
            setEvent({
                type: "error",
                text: "La longueur du code doit etre de 8 ou 13 caractères"
            });
        }
    }
    const randomBarcode = () => {
        const randomCode = BarcodeBuilder.buildRandomBarcode("sellers", storeSettings)
        insertBarcodeInValues(randomCode)
    }
    const openScanner = () => {
        setScanner(!scanner);
    }
    const insertBarcodeInValues = code => {
        handleChange("add", "barcode", code)
    }
    const removeBarcodeInValues = code => {
        handleChange("remove", "barcode", code)
    }
    const scanBarcode = res => {
        if (res.length === 0 || res[0].rawValue === undefined || res[0].rawValue === null || res[0].rawValue.length === 0)
            return;

        setBarcode(res[0].rawValue);
        setDetect(true);
    };
    const camError = err => {
        console.error("CAM ERR", err);
        setEvent({
            type: "error",
            text: "Erreur avec la caméra"
        });
    };
    const scanError = err => {
        console.error("SCAN ERR", err);
        setEvent({
            type: "error",
            text: "Erreur avec le scanner"
        });
    };
    const onTorchSwitch = () => {
        setIsTorchOn(!isTorchOn);
    }

    useEffect(() => {
        if (detect) {
            setTimeout(() => {
                openScanner();
                setDetect(false);
                addBarcode();
            }, 500);
        }
    }, [detect]);

    return (
        <>
            <div className={ "inputBarcode " + (classname !== undefined ? classname : "") }>
                <div className={"head"}>
                    {
                        !readonly
                        && <>
                            <InputText classname="extend" attribute="barcode" value={ barcode } readonly={ readonly } placeholder="Saisir un code barre" toUppercase={null} handleChange={ inputBarcode } />
                            <CrossIcon click={ addBarcode } />
                            <RandomIcon click={ randomBarcode } />
                            <ScanBarcodeIcon click={ openScanner } />
                        </>
                    }
                </div>
                <ul>{ buildList() }</ul>
            </div>
            {
                scanner
                && <>
                    <div className={"overlayer"} />
                    <div className={"overbox scanner"}>
                        <div className={"scannerFrame" + (detect ? " detect" : "")}>
                            <BarcodeScanner options={scannerOptions} onCapture={scanBarcode} onCameraError={camError} onScanError={scanError} />
                            {
                                isTorchSupported
                                ? <button onClick={onTorchSwitch}>{ isTorchOn ? "Eteindre" : "Allumer" } le flash</button>
                                : null
                            }
                        </div>
                        <div className={"buttons"}>
                            <button className={"cancel"} onClick={ openScanner }>Fermer</button>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default InputBarcode;